import moment from 'moment'

export default {
    install: function (Vue, options) {
        Vue.filter('formatDate', function (value, format) {
            if (typeof format === 'undefined') {
                format = 'MM/DD/YYYY hh:mm'
            }

            return moment(String(value)).format(format)
        })
    }
}



// WEBPACK FOOTER //
// ./src/plugins/moment.js